<template>
  <div id="loginPage">
    <ul class="lp-slideshow">
      <li><span>Image 01</span></li>
      <li><span>Image 02</span></li>
      <li><span>Image 03</span></li>
      <li><span>Image 04</span></li>
      <li><span>Image 05</span></li>
    </ul>

    <div class="container">
      <div class="row justify-content-center align-items-center" id="login-row">
        <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
          <div class="panel">
            <img class="companyCRMlogo" src="img/logos/payroll/genius_logo.svg" alt="Payroll CRM Logo">
            <img v-if="crmCompany === 'Genius Money'" class="companyCRMlogo" :src="require('img/logos/payroll/genius_logo.svg').default" alt="CRM LOGO">
            <img v-if="crmCompany === 'V3 Recruitment'" class="companyCRMlogo" :src="require('img/logos/recruitment/v3_logo.svg').default" alt="CRM LOGO">
            <img v-if="crmCompany === 'Build People'" class="companyCRMlogo" :src="require('img/logos/build_people/bp_logo.svg').default" alt="CRM LOGO">
            <div class="panel-heading">Locked</div>
            <div class="panel-body">
              <h5 class="body-text mb-3" style="color: #ffffff">
                To continue working please enter the password for {{ $store.state.auth.me.first_name }} {{ $store.state.auth.me.surname }}
              </h5>

              <ValidationObserver ref="loginForm" v-slot="{ handleSubmit }" slim>
                <form role="form" @submit.prevent="handleSubmit(unlockSubmit)" class="clearfix">
                  <ValidationProvider rules="required" v-slot="{errors, classes}" name="Password" tag="div" class="form-group">
                    <label class="form-label" for="password">Password</label>
                    <input v-model.trim="form.password" type="password" class="form-input requiredField" :class="classes" id="password" autocomplete="user-password" autofocus>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>

                  <button type="submit" class="btn orcaBtn mt-1" :disabled="$store.state.auth.logging_in">
                    <span v-if="$store.state.auth.logging_in" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Logging In ...</span>
                    <span v-else>Login</span>
                  </button>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  name: "login_lock",
  data() {
    return {
      form: {
        email: this.$store.state.auth.me.email,
        password: '',
        refresh_token: localStorage.getItem('refresh_token')
      },
    }
  },
  beforeMount() {
    this.revoke_token(this.$store.state.auth.me.id).then(() => {}).catch(() => this.$store.commit('LOGIN_LOCK', false));
  },
  computed: {
    ...mapState({me: state => state.auth.me})
  },
  methods: {
    ...mapActions(['unlock', 'revoke_token']),

    unlockSubmit() {
      this.errors = {};
      this.unlock(this.form).then(() => {
        this.$nextTick(() => this.$router.push('/'))
      }).catch(err => {
        this.$snotify.error('', '', {
          html: '<div class="snotifyToast__title"><span>' + err.response.statusText + '</span></div>' +
              '<div class="snotifyToast__body">' +
              '<div class="error_info">' +
              '<strong>ERROR CODE : </strong>' + err.response.status + '<br><br>' +
              '<strong class="error_details">ERROR DETAILS : </strong>' + err.response.data['message'] +
              '</div>' +
              '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
              '</div>',
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
html, body {
  margin:      0;
  padding:     0;
  height:      100%;
  width:       100%;
  font-family: $font-family-paragraph;
}

ol, ul {
  list-style: none;
}

body {
  background: #000;
  overflow-y: scroll;
  overflow-x: hidden;
}

.ie7 body {
  overflow: hidden;
}

#loginPage {
  min-height: 100vh;

  .lp-slideshow {
    background: #000000;

    &:after {
      content:    '';
      background: transparent url('../../img/login/pattern.png') repeat top left;
    }

    li {
      span {
        width:                       100%;
        height:                      100%;
        position:                    absolute;
        top:                         0;
        left:                        0;
        bottom:                      0;
        right:                       0;
        color:                       transparent;
        background-size:             cover;
        opacity:                     0;
        z-index:                     0;
        -webkit-backface-visibility: hidden;
        -webkit-animation:           imageAnimation 30s linear infinite 0s;
        -moz-animation:              imageAnimation 30s linear infinite 0s;
        -o-animation:                imageAnimation 30s linear infinite 0s;
        animation:                   imageAnimation 30s linear infinite 0s;
      }

      &:nth-child(1) span {
        background-image:    url('../../img/login/musk.jpg');
        background-position: left top;
      }

      &:nth-child(2) span {
        background-image:        url('../../img/login/gates.jpg');
        background-position:     right top;
        -webkit-animation-delay: 6s;
        -moz-animation-delay:    6s;
        -o-animation-delay:      6s;
        animation-delay:         6s;
      }

      &:nth-child(3) span {
        background-image:        url('../../img/login/einstein.jpg');
        background-position:     left top;
        -webkit-animation-delay: 12s;
        -moz-animation-delay:    12s;
        -o-animation-delay:      12s;
        animation-delay:         12s;
      }

      &:nth-child(4) span {
        background-image:        url('../../img/login/senna.jpg');
        background-position:     right top;
        -webkit-animation-delay: 18s;
        -moz-animation-delay:    18s;
        -o-animation-delay:      18s;
        animation-delay:         18s;
      }

      &:nth-child(5) span {
        background-image:        url('../../img/login/jobs.jpg');
        background-position:     left top;
        -webkit-animation-delay: 24s;
        -moz-animation-delay:    24s;
        -o-animation-delay:      24s;
        animation-delay:         24s;
      }
    }
  }

  .lp-slideshow, .lp-slideshow:after {
    position: fixed;
    width:    100%;
    height:   100%;
    top:      0;
    left:     0;
    z-index:  0;
  }

  .container {
    min-height: 100vh;

    #login-row {
      width:      100%;
      min-height: 100vh;

      .panel {
        background:    rgba($black, 0.75);
        border-radius: $border_radius;
        padding:       15px 10px 10px;
        box-shadow:    0 4px 5px 0 rgba($bc_3, 0.14), 0 1px 10px 0 rgba($bc_3, 0.12), 0 2px 4px -1px rgba($bc_3, 0.3);

        .companyCRMlogo {
          width:        150px;
          height:       auto;
          margin-left:  auto;
          margin-right: auto;
          display:      block;
        }

        .panel-heading {
          text-transform: uppercase;
          text-align:     center;
          margin-top:     10px;
          margin-bottom:  10px;
          font-size:      2.5em;
          color:          $white;
          font-weight:    bold;
          font-family:    $font-family-header;
        }

        .form-label {
          color:            $bc_1;
          background-color: transparent;
        }

        .form-input {
          color: $white;
        }

        .requiredField, .inputError {
          background: transparent !important;
        }

        input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active, input:-webkit-autofill:active:focus, input:-webkit-autofill.active.focus, textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, textarea:-webkit-autofill:active, textarea:-webkit-autofill:active:focus, textarea:-webkit-autofill.active.focus, select:-webkit-autofill, select:-webkit-autofill:hover, select:-webkit-autofill:focus, select:-webkit-autofill:active, select:-webkit-autofill:active:focus, select:-webkit-autofill.active.focus {
          -webkit-text-fill-color: $white !important;
        }
      }
    }
  }
}

@-webkit-keyframes imageAnimation {
  0% {
    opacity:                           0;
    -webkit-animation-timing-function: ease-in;
  }
  4% {
    opacity:                           0.5;
    -webkit-animation-timing-function: ease-in;
  }
  8% {
    opacity:                           1;
    -webkit-transform:                 scale(1.05);
    -webkit-animation-timing-function: ease-out;
  }
  17% {
    opacity:           1;
    -webkit-transform: scale(1.1) rotate(3deg);
  }
  35% {
    opacity:           0;
    -webkit-transform: scale(1.1) rotate(3deg);
  }
  100% {
    opacity: 0
  }
}

@-moz-keyframes imageAnimation {
  0% {
    opacity:                        0;
    -moz-animation-timing-function: ease-in;
  }
  4% {
    opacity:                        0.5;
    -moz-animation-timing-function: ease-in;
  }
  8% {
    opacity:                        1;
    -moz-transform:                 scale(1.05);
    -moz-animation-timing-function: ease-out;
  }
  17% {
    opacity:        1;
    -moz-transform: scale(1.1) rotate(3deg);
  }
  35% {
    opacity:        0;
    -moz-transform: scale(1.1) rotate(3deg);
  }
  100% {
    opacity: 0
  }
}

@-o-keyframes imageAnimation {
  0% {
    opacity:                      0;
    -o-animation-timing-function: ease-in;
  }
  4% {
    opacity:                      0.5;
    -o-animation-timing-function: ease-in;
  }
  8% {
    opacity:                      1;
    -o-transform:                 scale(1.05);
    -o-animation-timing-function: ease-out;
  }
  17% {
    opacity:      1;
    -o-transform: scale(1.1) rotate(3deg);
  }
  35% {
    opacity:      0;
    -o-transform: scale(1.1) rotate(3deg);
  }
  100% {
    opacity: 0
  }
}

@keyframes imageAnimation {
  0% {
    opacity:                   0;
    animation-timing-function: ease-in;
  }
  4% {
    opacity:                   0.5;
    animation-timing-function: ease-in;
  }
  8% {
    opacity:                   1;
    transform:                 scale(1.05);
    animation-timing-function: ease-out;
  }
  17% {
    opacity:   1;
    transform: scale(1.1) rotate(3deg);
  }
  35% {
    opacity:   0;
    transform: scale(1.1) rotate(3deg);
  }
  100% {
    opacity: 0
  }
}

/* Show at least something when animations not supported */
.no-cssanimations .lp-slideshow li span {
  opacity: 1;
}
</style>
